"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var FormGroupContext_1 = __importDefault(require("../FormGroup/FormGroupContext"));
var Icon_1 = __importDefault(require("../Icon"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var IconWrapper = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Wrapper = styled_components_1.default('label')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  min-width: ", ";\n  height: ", ";\n  cursor: pointer;\n  margin-right: ", ";\n\n  input[type='checkbox'] {\n    cursor: pointer;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n\n    & ~ ", " {\n      border-radius: ", ";\n      border: ", " solid\n        ", ";\n      transition: background 0.2s, border 0.2s;\n      svg {\n        position: relative;\n        top: ", ";\n        transform: scale(0);\n        transition: transform 0.2s ease-out;\n      }\n    }\n\n    &:checked ~ ", " {\n      border: ", " solid\n        ", ";\n      background: ", ";\n      svg {\n        transform: scale(1);\n      }\n    }\n    &:disabled ~ ", " {\n      border: ", " solid\n        ", ";\n      background-color: ", ";\n      cursor: ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n  min-width: ", ";\n  height: ", ";\n  cursor: pointer;\n  margin-right: ", ";\n\n  input[type='checkbox'] {\n    cursor: pointer;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n\n    & ~ ", " {\n      border-radius: ", ";\n      border: ", " solid\n        ",
    ";\n      transition: background 0.2s, border 0.2s;\n      svg {\n        position: relative;\n        top: ", ";\n        transform: scale(0);\n        transition: transform 0.2s ease-out;\n      }\n    }\n\n    &:checked ~ ", " {\n      border: ", " solid\n        ", ";\n      background: ", ";\n      svg {\n        transform: scale(1);\n      }\n    }\n    &:disabled ~ ", " {\n      border: ", " solid\n        ", ";\n      background-color: ", ";\n      cursor: ", ";\n    }\n  }\n"])), polished_1.rem(16), polished_1.rem(16), polished_1.rem(9), IconWrapper, function (_a) {
    var theme = _a.theme;
    return theme.checkbox.borderRadius;
}, polished_1.rem(1), function (_a) {
    var theme = _a.theme, error = _a.error;
    return error ? theme.color.danger : theme.form.placeholderColor;
}, polished_1.rem(1), IconWrapper, polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.checkbox.checkedBackgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.checkbox.checkedBackgroundColor;
}, IconWrapper, polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.checkbox.disabledBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.checkbox.disabledBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledCursor;
});
var Checkbox = function (props) {
    var _a = props.theme.checkbox, disabledCheckColor = _a.disabledCheckColor, checkColor = _a.checkColor;
    var value = React.useContext(FormGroupContext_1.default);
    return (React.createElement(Wrapper, { className: props.className, error: !!props.error },
        React.createElement("input", __assign({}, props, { type: "checkbox", id: props.id || value.id })),
        React.createElement(IconWrapper, null,
            React.createElement(Icon_1.default, { name: "check", color: !!props.disabled ? disabledCheckColor : checkColor, size: "s" }))));
};
exports.default = styled_components_1.withTheme(Checkbox);
var templateObject_1, templateObject_2;
